import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-g-twoone-twotwo',
  templateUrl: './g-twoone-twotwo.component.html',
  styleUrls: ['./g-twoone-twotwo.component.scss']
})
export class GTwooneTwotwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
